"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Descricao = exports.Titulo = exports.Image = exports.Container = void 0;
var react_1 = __importDefault(require("react"));
var rebass_1 = require("rebass");
var tema_1 = __importDefault(require("../../tema"));
var Container = function (_a) {
  var _b = _a.sx,
    sx = _b === void 0 ? {} : _b,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      boxShadow: tema_1.default.shadows.padrao,
      background: tema_1.default.colors.white,
      borderRadius: 6,
      paddingY: tema_1.default.spaces[3],
      paddingX: tema_1.default.spaces[2],
      textAlign: "center"
    }, sx)
  }, props));
};
exports.Container = Container;
var Image = function (_a) {
  var _b = _a.sx,
    sx = _b === void 0 ? {} : _b,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      mb: tema_1.default.spaces[4]
    }, sx)
  }, props));
};
exports.Image = Image;
var Titulo = function (_a) {
  var _b = _a.sx,
    sx = _b === void 0 ? {} : _b,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Text, __assign({
    sx: __assign({
      color: tema_1.default.colors.blue1,
      fontWeight: tema_1.default.fontWeights.bold,
      fontFamily: tema_1.default.fonts.heading,
      fontSize: 18,
      mb: tema_1.default.spaces[2]
    }, sx)
  }, props));
};
exports.Titulo = Titulo;
var Descricao = function (_a) {
  var _b = _a.sx,
    sx = _b === void 0 ? {} : _b,
    props = __rest(_a, ["sx"]);
  return react_1.default.createElement(rebass_1.Box, __assign({
    sx: __assign({
      color: tema_1.default.colors.gray1,
      fontWeight: tema_1.default.fontWeights.body,
      fontFamily: tema_1.default.fonts.body,
      fontSize: 18
    }, sx)
  }, props));
};
exports.Descricao = Descricao;